// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"5f6aac0d5f2e25afb4ea","883":"19ea51b8ed59c8dd71b8"}[chunkId] + ".js";
};